import React from "react";
import { getProductData, getProductNameBy } from "../../../services/productService";
import LegalbirdLoader from "../../../components/ContentLoader/LegalbirdLoader";
import ApplicationForm from "../../../components/ApplicationForm/ApplicationForm";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../services/reactQuery/reactQueryService";
import useProductParams from "../../../hooks/useProductParams";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function ApplicationFormPage() {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");
  const { data: product, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId),
  });

  return <LayoutAuthenticated sidebar={false}>{isLoading ? <LegalbirdLoader /> : <ApplicationForm product={product} />}</LayoutAuthenticated>;
}
